import * as Yup from 'yup';
import { getNullableIntegerSchema, getSelectSchema } from 'src/compass/shared/schemas';
import { getDateInMoment } from 'src/compass/shared/util/casMoment';

export const NoticeReceivedSchema  = Yup.object().shape({
  hasClaim: getSelectSchema('Has Claim').test('hasClaim','Has Claim is required.',(value) => value !== ''),
  claimDueByDate: Yup.date()
    .nullable()
    .when('hasClaim', {
      is: 'CLAIM',
      then: (schema) =>
        schema
          .required('Signed Claim Due By is required.')
          .min(getDateInMoment(), 'Signed Claim Due By must be in the future.')
          .max(
            getDateInMoment().add(60, 'days'),
            'Signed Claim Due By must be <= 60 days in the future.'
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
  claimNumber: getNullableIntegerSchema('Claim#').when('hasClaim', {
    is: 'CLAIM',
    then: (schema) => schema.required('Claim# is required.'),
  }),
});